// src/bus.js
import Vue from 'vue';
export const bus = new Vue(); // 创建事件总线实例



// WEBPACK FOOTER //
// ./src/bus.js